import { render, staticRenderFns } from "./MatchedCandidate.vue?vue&type=template&id=288fc5ff&scoped=true&"
import script from "./MatchedCandidate.vue?vue&type=script&lang=js&"
export * from "./MatchedCandidate.vue?vue&type=script&lang=js&"
import style0 from "./MatchedCandidate.vue?vue&type=style&index=0&id=288fc5ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fc5ff",
  null
  
)

export default component.exports